<template>
  <div class="seats-legend">
    <div
      class="seats-legend__item seats-legend__item--unavailable"
      v-if="!showSeatOffered"
    >
      <img src="/assets/seat-icons/seat_taken--0.gif" alt="" />
      <p>{{ $t("seats_legend.unavailable") }}</p>
    </div>
    <div
      class="seats-legend__item seats-legend__item--available"
      v-if="!showSeatOffered"
    >
      <img src="/assets/seat-icons/seat.png" alt="Seat available" />
      <p>{{ $t("seats_legend.available") }}</p>
    </div>
    <div class="seats-legend__item seats-legend__item--selected">
      <img src="/assets/seat-icons/seat_selected--0.gif" alt="" />
      <p>{{ $t("seats_legend.selected") }}</p>
    </div>
    <div
      class="seats-legend__item seats-legend__item--offered"
      v-if="showSeatOffered && !isHotShow"
    >
      <img src="/assets/seat-icons/SeatIcon_Offered_0.gif" alt="" />
      <p>{{ $t("seats_legend.offered") }}</p>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "seats-legend",
  props: {
    showSeatOffered: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    ...mapGetters(['isHotShow'])
  }
};
</script>